module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "d-flex fd-column flex-1"
  }, [_c('v-progress-linear', {
    attrs: {
      "color": "primary",
      "indeterminate": "",
      "rounded": "",
      "height": "3"
    }
  }), _c('small', {
    staticClass: "text-muted font-size-10"
  }, [_vm._v("obteniendo lista...")])], 1)]) : _vm._e(), (!_vm.isLoading && !_vm.small) ? _c('div', {
    staticClass: "d-flex flex-wrap"
  }, _vm._l((_vm.estados), function(e, index) {
    return _c('div', {
      staticClass: "estado-dot",
      on: {
        "click": function($event) {
          return _vm.selectEstado(e)
        }
      }
    }, [_c('v-tooltip', {
      attrs: {
        "top": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;
          var attrs = ref.attrs;

          return [(_vm.tipo === 'garantia') ? _c('v-icon', _vm._g(_vm._b({
            attrs: {
              "size": _vm.small ? 14 : 28,
              "color": e.orden <= _vm.estado.orden ? ("" + (!_vm.small  && 'primary')) : 'background'
            }
          }, 'v-icon', attrs, false), on), [_vm._v("fiber_manual_record")]) : _c('v-icon', _vm._g(_vm._b({
            attrs: {
              "size": _vm.small ? 14 : 28,
              "color": e.codigo <= _vm.estado.codigo ? ("" + (!_vm.small  && 'primary')) : 'background'
            }
          }, 'v-icon', attrs, false), on), [_vm._v("fiber_manual_record")])]
        }
      }], null, true)
    }, [_c('small', [_vm._v(_vm._s(e.descripcion))])])], 1)
  }), 0) : _vm._e(), (!_vm.isLoading) ? _c('div', {
    staticClass: "d-flex",
    class: {
      'jc-center ai-center': _vm.showClear
    }
  }, [(_vm.estado && _vm.estado.descripcion) ? _c('div', {
    staticClass: "text-left"
  }, [(_vm.small) ? _c('small', {
    staticClass: "font-size-10 text-muted"
  }, [_vm._v(_vm._s(("Etapa: " + _vm.etapa)) + " / " + _vm._s(_vm.estado.descripcion.substring(0, 30)))]) : _c('small', {
    staticClass: "font-size-13 primary--text font-weight-700"
  }, [_vm._v(" " + _vm._s(_vm.estado.descripcion))])]) : _vm._e(), (_vm.showClear) ? _c('v-divider', {
    staticClass: "mx-2"
  }) : _vm._e(), (_vm.showClear) ? _c('div', {
    staticClass: "ml-3"
  }, [_c('v-btn', {
    attrs: {
      "link": "link",
      "disabled": !_vm.estado.codigo,
      "x-small": "x-small",
      "color": "error"
    },
    on: {
      "click": function($event) {
        return _vm.limpiarEstado(true)
      }
    }
  }, [_vm._v("Limpiar")])], 1) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-112d9eae","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_estados_tickets.vue
// module id = 477
// module chunks = 1